import styled from "@emotion/styled";

import { SpacingValues } from "@brexhq/shared/types/SpacingScale";

export const Form = styled.form<{
  backgroundColor?: string;
  hasBorder?: boolean;
  hasShadow?: boolean;
  padding?: SpacingValues;
}>(({ theme, backgroundColor, hasBorder, hasShadow, padding }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing[24],
  fieldset: {
    border: "none",
    padding: 0,
  },
  // Whether the main wrapper has a background color
  ...(backgroundColor && {
    borderRadius: theme.borders.radius.default,
    background: theme.colors.background.primary,
  }),
  ...(hasBorder && { ...theme.borders.defaultBorder.all }),
  ...(hasShadow && {
    boxShadow: theme.shadows.faint,
  }),
  ...(padding
    ? { padding: theme.spacing.MED[padding] }
    : { padding: theme.spacing[16] }),
}));
